import * as React from 'react';
import { Modal, useDeviceType, useToast } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { selectReferralLinkFallbackModal } from '../../../selectors';
import { trackCopySuccessShow } from '../Hero/tracking';
import { useReferrerAppDispatch } from '../../../hooks';
import { setReferralLinkFallbackModalClose } from '../../../slices';
import { ReferralLinkFallbackModalContent } from '../../../components/Modals';

export const ReferralLinkFallbackModal: React.FC = () => {
  const dispatch = useReferrerAppDispatch();
  const toastApi = useToast({ placement: 'top-right' });

  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';

  const { isOpen, referralLink } = useSelector(selectReferralLinkFallbackModal);

  const handleCloseModal = React.useCallback(() => {
    dispatch(setReferralLinkFallbackModalClose());
  }, [dispatch]);

  const handleCopy = React.useCallback(async () => {
    if (window?.navigator?.clipboard?.writeText) {
      await window.navigator.clipboard.writeText(referralLink);

      toastApi.open({ type: 'success', text: 'Ссылка скопирована' });
      trackCopySuccessShow();
      handleCloseModal();
    }
  }, [referralLink]);

  return (
    <Modal open={isOpen} onOpenChange={handleCloseModal} size="S">
      <ReferralLinkFallbackModalContent isPhone={isPhone} onClick={handleCopy} />
    </Modal>
  );
};
